import { RespondecoPromise } from '@/shared/utils/respondeco-promise'
import { RespondecoError } from '@/shared/utils/respondeco-error'
import { Api } from '@/api/api'

export class PasswordRecoveryService {
  private _pending: false | 'check-token' | 'initialize-recovery' | 'update-password' = false

  public get pending() {
    return this._pending
  }

  public checkToken(token: string): RespondecoPromise<void, RespondecoError> {
    this._pending = 'check-token'

    return Api.Account.checkTokenValidity({
      token,
    }).finally(() => {
      this._pending = false
    })
  }

  public initializeRecovery(username: string): RespondecoPromise<void, RespondecoError> {
    this._pending = 'initialize-recovery'

    return Api.Account.initiatePasswordRecovery({
      passwordRecoveryInitiate: {
        username,
      },
    }).finally(() => {
      this._pending = false
    })
  }

  public updatePassword(password: string, token: string): RespondecoPromise<void, RespondecoError> {
    this._pending = 'update-password'

    return Api.Account.updatePassword({
      passwordRecoveryUpdate: {
        password,
        token,
      },
    }).finally(() => {
      this._pending = false
    })
  }
}
